import { render, staticRenderFns } from "./column-context-menu-factory.vue?vue&type=template&id=0a3050f5"
import script from "./column-context-menu-factory.vue?vue&type=script&lang=js"
export * from "./column-context-menu-factory.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports